import { useState, useEffect } from "react";
import { useQuery } from "@apollo/react-hooks";
import { gql } from "apollo-boost";
import { useNavigate } from "react-router-dom";
import { sellerCollectionUrl } from "../../../util/url";

const GET_GUIDE_COLLECTIONS = gql`
  {
    getGuideCollections {
      id
      tab_name
      title
    }
  }
`;

const GET_GUIDE_COLLECTION_HEADER = gql`
  query GetGuideCollection($guide_collection_id: ID!) {
    getGuideCollection(guide_collection_id: $guide_collection_id) {
      title
      sub_title
      description
      resizedBigImage
      aspect_ratio
    }
  }
`;

/**
 * 셀러 컬렉션 데이터를 관리하는 커스텀 훅
 * 컬렉션 목록과 현재 선택된 컬렉션의 데이터를 가져옵니다.
 */
export default function useSellerCollectionData(initialTabId) {
  const [activeTab, setActiveTab] = useState(initialTabId || null);
  const navigate = useNavigate();

  const { data: collectionsData } = useQuery(GET_GUIDE_COLLECTIONS);
  const { data: collectionData, loading: collectionLoading } = useQuery(
    GET_GUIDE_COLLECTION_HEADER,
    {
      variables: { guide_collection_id: initialTabId },
      fetchPolicy: "cache-and-network",
      skip: !initialTabId,
    },
  );

  // 초기 탭 설정
  useEffect(() => {
    if (initialTabId) {
      setActiveTab(initialTabId);
    }
  }, [initialTabId]);

  // 컬렉션이 없을 경우 첫 번째 컬렉션으로 리다이렉트
  useEffect(() => {
    if (
      collectionsData &&
      collectionsData.getGuideCollections &&
      collectionsData.getGuideCollections.length > 0 &&
      !activeTab
    ) {
      navigate(sellerCollectionUrl(collectionsData.getGuideCollections[0]), {
        replace: true,
      });
    }
  }, [collectionsData, activeTab, navigate]);

  // 메타 타이틀 생성
  const getMetaTitle = () => {
    let metaTitle = "후루츠패밀리 셀러 컬렉션";
    if (
      collectionData &&
      collectionData.getGuideCollection &&
      collectionData.getGuideCollection.title
    ) {
      metaTitle = `${collectionData.getGuideCollection.title} | 전국 빈티지샵, 후루츠패밀리에서 디깅하세요!`;
    }
    return metaTitle;
  };

  return {
    collectionsData,
    collectionData: collectionData && collectionData.getGuideCollection,
    collectionLoading,
    activeTab,
    metaTitle: getMetaTitle(),
  };
}
